import React from 'react';
import { reduxForm, Field } from 'redux-form';

import { SelectInput } from '../SelectInput';
import { TextInput } from '../TextInput';
import { HologramService } from '../../services';
import i18next from "i18next";

const PROVIDER_OPTIONS = [
  {label: "Hologram", value: "hologram"}
]

const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2
})

const validate = values => {
  const errors = {};
  const validICCID = /^[a-zA-Z0-9]{19,20}$/

  if (!values.provider) {
    errors.provider = i18next.t('messages.please-select-provider');
  }

  if (!values.ratePlan) {
    errors.ratePlan = i18next.t('messages.please-select-rate-plan');
  }

  if (!values.iccid) {
    errors.iccid = i18next.t('messages.please-enter-iccid');
  } else if (!validICCID.test(values.iccid)) {
    errors.iccid = i18next.t('messages.please-enter-valid-iccid')
  }

  return errors;
}

class DeviceSIMActivationForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ratePlanOptions: [],
      loading: true
    }

    this.props.initialize({
      provider: PROVIDER_OPTIONS[0]
    });
  }

  componentDidMount() {
    this.refreshRatePlans(PROVIDER_OPTIONS[0]);
  }

  refreshRatePlans(selectedProvider) {
    if (selectedProvider.value === 'hologram') {
      HologramService.getRatePlans().then(response => {
        this.setState({
          ratePlanOptions: response.data.sort((a, b) => {return a.id - b.id}).map(plan => {
            const zoneKey = Object.keys(plan.zones)[0];
            const zone = zoneKey ? plan.zones[zoneKey] : null;
            let basePrice = zone && zone.amount ? currencyFormatter.format(zone.amount) : i18next.t('pages.device-configuration.unknown-price');
            return {label: `${plan.name} - ${basePrice}`, value: plan.id, zone: zone}
          }),
          loading: false
        });
      }).catch(err => {
        console.error(err);
      });
    }
  }

  render() {
    if (this.state.loading) {
      return (<div className="loader">{ i18next.t('loading') }</div>);
    } else {
      return (
          <form onSubmit={this.props.handleSubmit}>
            <div className="form-group">
              <label>{ i18next.t('form-labels.provider') }</label>
              <Field
                name="provider"
                options={PROVIDER_OPTIONS}
                component={SelectInput}
                onChange={this.refreshRatePlans.bind(this)}
              />
            </div>
            <div className="form-group">
              <label>{ i18next.t('form-labels.rate-plan') }</label>
              <Field
                name="ratePlan"
                options={this.state.ratePlanOptions}
                component={SelectInput}
              />
            </div>
            <div className="form-group">
              <Field
                label="ICCID"
                name="iccid"
                component={TextInput}
              />
            </div>
            <ul className="list-inline clearfix">
                <li><button type="submit" className="btn btn-primary btn-block">{ i18next.t('form-labels.save') }</button></li>
                <li><button type="cancel" className="btn btn-default btn-block" onClick={this.props.onCancel}>{ i18next.t('form-labels.cancel') }</button></li>
            </ul>
          </form>
      );
    }
  }
}

export default reduxForm({ form: 'DeviceSIMActivationForm', validate })(DeviceSIMActivationForm);
